import Vue from 'vue'

const PayQrcode = Vue.extend({
  name: 'PayQrcode',
  data() {
    return {
      msg: ''
    }
  },
  methods: {
    close() {
      this.msg = ''
    },
    show({ msg }) {
      this.msg = msg
    }
  },
  render(h) {
    return h('div', {
      'directives': [{
        name: 'show',
        value: this.msg
      }],
      'class': ['PayQrcode'],
      'style': 'position:fixed;top:0;left:0;right:100%;width:100vw;height:100vh;display:flex;justify-content:center;align-items:center;background:rgba(0,0,0,0.5);z-index:9999;'
    }, [
      h('div',
        { style: 'box-sizing:border-box;display:flex;justify-content:center;align-items:center;flex-direction:column;padding: 20px;background:#fff;border-radius:6px;width:210px;' },
        [
          h('img', {
            attrs: { src: `/live/nt?data=${this.msg}` },
            style: 'display: block;width: 100px;height: 100px;margin: 10px auto 10px;background:#f0f0f0;'
          }),
          h('div', { style: 'color: #8c8c8c;font-size: 12px;' }, ['手机扫码支付']),
          h('button', {
            'style': 'color:#8c8c8c;font-size:12px;margin-top:20px;padding:10px;width:170px;background:#f0f0f0;border-radius:4px;',
            'on': {
              'click': this.close
            }
          }, ['关闭'])
        ]
      )
    ])
  }
})

window.addEventListener('load', () => {
  const el = document.getElementsByClassName('PayQrcode')[0]
  if (el) {
    document.removeChild(el)
  }
  const div = document.createElement('div')
  document.body.appendChild(div)
  window.payQrcode = new PayQrcode({ el: div })
})
